import { render, staticRenderFns } from "./JobsWidget.vue?vue&type=template&id=18bcee1c&scoped=true"
import script from "./JobsWidget.vue?vue&type=script&lang=js"
export * from "./JobsWidget.vue?vue&type=script&lang=js"
import style0 from "./JobsWidget.vue?vue&type=style&index=0&id=18bcee1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bcee1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18bcee1c')) {
      api.createRecord('18bcee1c', component.options)
    } else {
      api.reload('18bcee1c', component.options)
    }
    module.hot.accept("./JobsWidget.vue?vue&type=template&id=18bcee1c&scoped=true", function () {
      api.rerender('18bcee1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/JobsWidget.vue"
export default component.exports